<template>
  <div class="upload-image-container">
    <el-upload
      class="image-uploader"
      action="#"
      :show-file-list="false"
      :http-request="uploadImage"
      :before-upload="beforeUpload"
    >
      <img v-if="value" :src="value" class="uploaded-image" />
      <i v-else class="el-icon-plus image-uploader-icon"></i>
    </el-upload>
    <div v-if="value" class="upload-actions">
      <el-button type="text" size="mini" @click="handleRemove">删除</el-button>
    </div>
  </div>
</template>

<script>
import COS from 'cos-js-sdk-v5'

export default {
  name: 'UploadImage',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 生成唯一标识
    guid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    // 上传前的校验
    beforeUpload (file) {
      const isJPG = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JPEG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    // 自定义上传逻辑
    uploadImage (params) {
      const _this = this
      const file = params.file
      const cos = new COS({
        SecretId: 'AKID4zkFYr00sXyB93mEajgroVxADRaZRBHI',
        SecretKey: '2eCtUxHVba2QfliWBodOyLUZZZR87wc5'
      })
      
      cos.sliceUploadFile({
        Bucket: 'yunjixie-1317685697',
        Region: 'ap-beijing',
        Key: this.guid() + (file.name.substring(file.name.lastIndexOf('.')) || '.png'),
        Body: file
      }, function (err, data) {
        if (err) {
          console.error('上传失败', err)
          _this.$message.error('图片上传失败')
        } else if (data) {
          const url = 'https://' + data.Location
          _this.$emit('input', url)
          _this.$emit('change', url)
          _this.$message.success('上传成功')
        }
      })
    },
    // 移除图片
    handleRemove () {
      this.$emit('input', '')
      this.$emit('change', '')
    }
  }
}
</script>

<style scoped>
.upload-image-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.image-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.image-uploader:hover {
  border-color: #409eff;
}
.image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.uploaded-image {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: contain;
}
.upload-actions {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadImage/index.vue